import App from './App';

window.addEventListener('DOMContentLoaded', () => new App());